/**
 * Dev section layout — sub-nav, dev key, outlet.
 */
import { useState } from "react";
import { NavLink, Outlet } from "react-router-dom";
import { KeyRound, ScrollText, Radio, Wrench } from "lucide-react";
import { getDevKey, setDevKey } from "../../lib/devKey";

const tabs = [
  { to: "/dev", label: "Tools", icon: Wrench, end: true },
  { to: "/dev/logs/live", label: "Live", icon: Radio, end: false },
  { to: "/dev/logs", label: "Sessions", icon: ScrollText, end: true },
];

export const DevLayout: React.FC = () => {
  const [devKey, setDevKeyState] = useState(getDevKey);
  const [saved, setSaved] = useState(false);

  const saveKey = (): void => {
    setDevKey(devKey);
    setSaved(true);
    setTimeout(() => setSaved(false), 2000);
  };

  return (
    <div className="space-y-4">
      <header className="space-y-3">
        <div>
          <h1 className="text-2xl font-bold">Developer</h1>
          <p className="text-sm text-gray-500">
            Tools, session logs, and live server/browser diagnostics.
          </p>
        </div>
        <nav className="flex flex-wrap gap-1">
          {tabs.map((t) => (
            <NavLink
              key={t.to}
              to={t.to}
              end={t.end}
              className={({ isActive }) =>
                `inline-flex items-center gap-1.5 rounded-lg px-3 py-1.5 text-sm font-medium transition ${
                  isActive
                    ? "bg-indigo-100 text-indigo-700 dark:bg-indigo-950 dark:text-indigo-200"
                    : "text-gray-600 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-800"
                }`
              }
            >
              <t.icon className="h-4 w-4" />
              {t.label}
            </NavLink>
          ))}
        </nav>
        <div className="card flex flex-wrap items-end gap-2 p-3">
          <div className="min-w-[200px] flex-1">
            <label className="mb-1 flex items-center gap-1 text-xs font-medium text-gray-600 dark:text-gray-400">
              <KeyRound className="h-3.5 w-3.5" />
              Dev key (production)
            </label>
            <input
              type="password"
              className="input w-full text-sm"
              placeholder="X-Dev-Key value from server .env"
              value={devKey}
              onChange={(e) => setDevKeyState(e.target.value)}
            />
          </div>
          <button type="button" className="btn btn-primary" onClick={saveKey}>
            {saved ? "Saved" : "Save key"}
          </button>
          <p className="w-full text-[11px] text-gray-500">
            Stored in this browser only. Required for dev APIs and log streaming on production
            (Hetzner).
          </p>
        </div>
      </header>
      <Outlet />
    </div>
  );
};
